function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D1E5F5"
    },
    cx: 256,
    cy: 120.889,
    r: 120.889
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1E5F5"
    },
    d: "M412.444,512c31.418,0,56.889-25.471,56.889-56.889c0-117.82-95.514-213.333-213.333-213.333 S42.667,337.291,42.667,455.111c0,31.418,25.471,56.889,56.889,56.889H412.444z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B4D8F1"
    },
    points: "255.999,241.778 255.999,241.778 256,241.778  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4D8F1"
    },
    d: "M376.889,120.889C376.889,54.124,322.765,0,256,0h-0.001v241.778H256 C322.765,241.778,376.889,187.654,376.889,120.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4D8F1"
    },
    d: "M256,241.778L256,241.778L255.999,512h156.446c31.418,0,56.889-25.471,56.889-56.889 C469.333,337.291,373.82,241.778,256,241.778z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.98abb72a97786429521a0d4d8c9abd0f.svg";
export { ForwardRef as ReactComponent };